import { render, staticRenderFns } from "./RestoreReviewTable.vue?vue&type=template&id=9fb6e592&scoped=true&"
import script from "./RestoreReviewTable.vue?vue&type=script&lang=js&"
export * from "./RestoreReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./RestoreReviewTable.vue?vue&type=style&index=0&id=9fb6e592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb6e592",
  null
  
)

export default component.exports